import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ContactStyles from './ContactStyles.scss';
import md5 from 'blueimp-md5';
import axios from 'axios';

export default class ContactShow extends React.Component {
  static propTypes = {
    avatarCache: PropTypes.object,
    updateAvatarCache: PropTypes.func,
    contact: PropTypes.object,
    extended: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.getAvatarLink = this.getAvatarLink.bind(this);
  }

  componentDidMount() {
    const email = this.props.contact.node.user_contact_emails ?
      this.props.contact.node.user_contact_emails.edges[0] : null;
    const address = email ? email.node.address : null;
    this.getAvatarPhoto(address);
  }

  componentWillReceiveProps(nextProps) {
    let currentEmailAddress = null;
    if (
      this.props.contact.node.user_contact_emails &&
      this.props.contact.node.user_contact_emails.edges[0] &&
      this.props.contact.node.user_contact_emails.edges[0].node.address
    ) {
      currentEmailAddress = this.props.contact.node.user_contact_emails.edges[0].node.address;
    }
    if (
      nextProps.contact.node.user_contact_emails &&
      nextProps.contact.node.user_contact_emails.edges[0] &&
      nextProps.contact.node.user_contact_emails.edges[0].node.address !==
        currentEmailAddress
    ) {
      this.getAvatarPhoto(
        nextProps.contact.node.user_contact_emails.edges[0].node.address
      );
    }
  }

  getAvatarLink(email) {
    const emailHash = md5(email);
    return `https://www.gravatar.com/avatar/${emailHash}?s=50&d=404`;
  }

  getAvatarPhoto(email) {
    const emailHash = md5(email);
    if (this.props.avatarCache[emailHash] === undefined) {
      axios
        .get(this.getAvatarLink(email))
        .then(() => {
          this.props.updateAvatarCache(emailHash, true);
        })
        .catch(() => {
          this.props.updateAvatarCache(emailHash, false);
        });
    }
  }

  render() {
    const { contact } = this.props;
    const primaryEmail = (contact.node.user_contact_emails && contact.node.user_contact_emails.edges[0] !== undefined ? contact.node.user_contact_emails.edges[0].node.address : null);
    const emailHash = md5(primaryEmail);
    return (
      <div style={{ display: 'flex', paddingLeft: '1em', marginTop: '1em' }}>
        <div className={ContactStyles.avatarWrapper}>
          <div
            className={ContactStyles.avatar}
            style={{
              backgroundImage: this.props.avatarCache[emailHash]
                ? `url(${this.getAvatarLink(primaryEmail)})`
                : '',
              backgroundPosition: 'center',
              backgroundSize: 'cover'
            }}
          >
            {!this.props.avatarCache[emailHash] && contact.node.first_name &&
              <span className={ContactStyles.avatarText}>
                {contact.node.first_name.charAt(0).toUpperCase()}
              </span>}
          </div>
        </div>
        <div className={[ContactStyles.contact, this.props.extended ? '' : ContactStyles.hideOverflow].join(' ')}>
          <span className={ContactStyles.name}>
            {contact.node.first_name} {contact.node.last_name}
          </span>
          {<div>{contact.node.company_name}</div>}
          <div className={ContactStyles.label} style={{ margin: 0 }}>
            {_.capitalize(contact.role)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ContactShow.js